<template lang="slm">
  section :class="{'Folk' : $route.name === 'Organisasjonen'}"
    .container
      .columns.is-multiline
        .column.is-12.PersonCard-list v-if="$route.name === 'Organisasjonen'"
          h2.title.sectionHeading {{title}}
        .column :class="$route.name === 'Chapter'? 'is-12' : 'is-8 is-offset-2 is-7-widescreen'" v-else=""
          .content
            h4 {{title}}
        .column :class="$route.name === 'Chapter' || $route.name === 'Organisasjonen' ? 'is-12' : 'is-10 is-offset-1'"
          .content
            .PersonCard-list.columns.is-multiline
              .column :class="$route.name === 'Organisasjonen' ? 'is-4' : 'is-half'" v-for="member in members"
                person-card :person="member.person" :role="member.role"
</template>

<script>
import personCard from '@/components/PersonCard'

export default {
  components: {
    'person-card': personCard
  },
  props: ['title', 'members'],
  created () {

  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/Group.vue